import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { RegisterService, MetaDataService } from '../index';


@Injectable({
  providedIn: 'root'
})
export class MetadataResolver implements Resolve<boolean> {

  constructor(
              private registerService: RegisterService,
              private metadata:MetaDataService
            ) {}

  resolve (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> 
          {
            return new Promise((resolve, rej) => {
              this.registerService.getCityProvinceMetaData().subscribe((res: any) => {
                const RegBusiness = res['data'];
                this.metadata.metaData.RegBusiness = RegBusiness;                
                resolve(true);                
              });
            });
          }
}
